import React from 'react';
import _ from 'lodash';
import METHOD_NAMES from './methodNames';

export default function CardLogoList(props) {
  const className =
    'card-logos__list' + (props.className ? ` ${props.className}` : '');

  return (
    <ul className={className}>
      {_.map(METHOD_NAMES, key => {
        return (
          <li
            key={key}
            className={`card-logos__list-item card-logos__list-item--${key}`}
          />
        );
      })}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./shared/components/payment/logoList.js